import React, {useEffect, useRef, useState} from 'react'
import './style.scss'
import '../../assets/style/main.css'
import CROSS_ICON from "../../assets/images/icons/x.png"
import CHECKMEMBER_ICON from '../../assets/images/icons/checkmember-icon.png'
import NH_CONNECT_ICON from '../../assets/images/icons/nh-connect.png'
import { DecryptedOBJ, DecryptedText, EncryptedText } from '../../utils/Encryption';
import $ from 'jquery'
import SUCCESS_COVER from '../../assets/images/cover/signup-success.png'
import CLOSE_ICON from '../../assets/images/icons/cross.png'
import KYC_COVER from '../../assets/images/cover/kyc-popup.png'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)

function SignUp_Success() {
    let onceMount = useRef(true);

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false; 
        }
    }, [])

    const pageInit = async() => {
        console.log('session_last_active: ', EncryptedText('session_last_active'));
        await checkCurrentURL();
        isPageLoading(false);
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
            resolve();
        })
    }

    const onSubmit = () => {
        onSkip()
        // let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
        // console.log(patientData);
        // if(!!patientData)
        // {
        //     //! bypass
        //     let isUpdateKYC = patientData.data.isUpdateKYC; 
        //     // let isUpdateKYC = true; 
        //     if(isUpdateKYC)
        //     {
        //         openAlertKYC() 
        //     }else
        //     {
        //         onSkip()
        //     }
        // }else
        // {
        //     onSkip()
        // }
    }

    const onSkip = () => {
        localStorage.removeItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL);
        localStorage.removeItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL);

        let callbackURLEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL)
        
        if(!!callbackURLEnc)
        {
            let callbackURLDec = DecryptedText(callbackURLEnc);
            console.log('callbackURLDec: ', callbackURLDec);
            if(callbackURLDec.indexOf('/ref') >= 0)
            {
                let refRedirect = !!localStorage.getItem('refredirect') ? DecryptedText(localStorage.getItem('refredirect')) : null;
                let newCallbackURL = callbackURLDec.replace('/ref', `/${refRedirect}`)
                let path = newCallbackURL;
                location.href = path; 
                resolve();
            }else
            {
                let path = callbackURLDec;
                location.href = path;
                resolve();
            }
        }   
    }

    const goToKYC = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/overview-1`;
    }

    const openAlertKYC = () => {
        let alertConfirmElem = (
            <div className="swal-cfpm-kyc">
                <div className="top">
                    <img onClick={handleCloseAlert} src={CLOSE_ICON} />
                </div>

                <div className="cover">
                    <img src={KYC_COVER} />
                </div>
        
                <div className="mid">
                    <h2 className="title">คุณยังไม่ได้อัปเดตข้อมูล</h2>
                    <p className="desc">
                        โปรดอัปเดตข้อมูลยืนยันตัวตนของคุณตอนนี้ หรือติดต่อเจ้าหน้าที่ เพื่อใช้งานแอปพลิเคชั่น
                    </p>
                </div>
        
                <div className={`bottom`}>
                    <button type="button" onClick={goToKYC}>
                        อัปเดตตอนนี้
                    </button>
                    <button type="button" onClick={onSkip}>
                        ข้ามไปก่อน
                    </button>
                </div>
            </div>
        );
    
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    
    };
    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src={CLOSE_ICON} />
                </div>
        
                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>
        
                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );
    
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    
    };
    
    const handleCloseAlert = () => {
        MySwal.close();
    };

    return (
        <div className='sgnup_success_con'>
            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />     
                </div> 
            </div>

            <div className="header">
                <img src={SUCCESS_COVER}/>
            </div>

            <div className="title-wrap">
                <h2>
                    ตรวจสอบข้อมูลสำเร็จ
                </h2>
                <p>
                    คุณได้ลงทะเบียนเข้าใช้บริการเรียบร้อยแล้ว กับทาง N Health
                </p>
            </div>

            <div className="submit">
                <button onClick={onSubmit}>
                    เข้าสู่หน้าหลัก
                </button>
            </div>

            <div className="copyright">
                <p>พบปัญหาติดต่อ Call Center <span className="text-blue">02-762-4000</span> หรือ <br/> <span className='text-blue'>ศูนย์ช่วยเหลือ</span></p>
            </div>
            
            <PageLoader />
        </div>
    )
}

export default SignUp_Success